import memberSignApi from '@/api/api-memberSign';

export default {
    state: {
        signRecordJson: [] // 签到记录以年月为key的json
    },
    mutations: {
        setSignRecord(state, {
            yearAndMonth,
            signRecord
        }) {
            state.signRecordJson[yearAndMonth] = signRecord
        }
    },
    actions: {
        // 获取当前可用的签到规则
        getMemberSignRules() {
            return new Promise((resolve, reject) => {
                memberSignApi.getMemberSignRules().then(res => {
                    // console.log('签到规则', res);
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 获取历史签到记录/MemberSign/SignRecordList
        getMemberSignRecordList({
            state,
            commit
        }, yearAndMonth) {
            return new Promise((resolve, reject) => {
                if (typeof(state.signRecordJson[yearAndMonth]) !== 'undefined') {
                    resolve(state.signRecordJson[yearAndMonth])
                } else {
                    memberSignApi.getMemberSignRecordList({
                        signMonth: yearAndMonth
                    }).then(res => {
                        // console.log('签到记录', res);
                        const data = res;
                        // commit('setSignRecord', yearAndMonth, signRecord)
                        resolve(data)
                    }).catch(err => {
                        reject(err)
                    })
                }
            })
        },
        // 获取签到记录
        getMemberSignRecord({
            state,
            commit
        }, yearAndMonth) {
            return new Promise((resolve, reject) => {
                if (typeof(state.signRecordJson[yearAndMonth]) !== 'undefined') {
                    resolve(state.signRecordJson[yearAndMonth])
                } else {
                    memberSignApi.getMemberSignRecord().then(res => {
                        // console.log('签到记录', res);
                        const data = res;
                        // commit('setSignRecord', yearAndMonth, signRecord)
                        resolve(data)
                    }).catch(err => {
                        reject(err)
                    })
                }
            })
        },
        // 签到动作
        memberSign() {
            return new Promise((resolve, reject) => {
                memberSignApi.memberSign().then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/module/memberSign.js